import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const ReviewDefaultsDialog = ({ row, onClose, onSave }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const save = async () => {
    setBusy(true); setError("");
    try { await onSave(row.key, reason.trim()); onClose(); }
    catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent className="opaque-editable-fields max-w-[calc(100vw-2rem)] sm:max-w-lg [&>button:last-child]:hidden" data-testid="review-default-dialog">
      <div className="absolute right-3 top-3"><DialogClose asChild><Button data-testid="review-default-close" disabled={busy} variant="ghost" size="icon" aria-label="Chiudi conferma predefinito"><X size={16} /></Button></DialogClose></div>
      <DialogHeader><DialogTitle data-testid="review-default-title">Salva come predefinito aziendale</DialogTitle>
        <DialogDescription data-testid="review-default-description">{row.label}: {row.value} {row.unit}. {row.default_scope && `Ambito: ${row.default_scope}. `}Il nuovo valore sarà disponibile per i prossimi preventivi. Le bozze già salvate non cambiano.</DialogDescription></DialogHeader>
      <Input data-testid="review-default-reason" aria-label="Motivazione del nuovo predefinito" placeholder="Motivazione" maxLength={1500} value={reason} onChange={e => setReason(e.target.value)} disabled={busy} />
      {error && <p role="alert" data-testid="review-default-error" className="text-sm text-destructive">{error}</p>}
      <div className="flex flex-wrap gap-2"><Button data-testid="review-default-confirm" disabled={busy || reason.trim().length < 3} onClick={save}>Conferma predefinito</Button>
        <Button data-testid="review-default-cancel" variant="outline" disabled={busy} onClick={onClose}>Annulla</Button></div>
    </DialogContent>
  </Dialog>;
};